import React from 'react';
import Widget from 'shared/components/Widget';
import 'modules/hiring/components/candidatesAwaitingReview/candidatesAwaitingReview.scss';
import TypographyWithI18N from 'shared/components/TypographyWithI18N';
import { colors } from 'styles/colors';
import RecentHiringActivityContentWrapper from 'modules/hiring/components/recentHiringActivity/recentHiringActivityContentWrapper';

const RecentHiringActivityWidget = () => {
  const recentDaysLimit = 7;

  return (
    <Widget
      id='recent-hiring-activity-widget'
      data-testid='recent-hiring-activity-widget'
      headingProps={{
        i18nKey: 'recentHiringActivity',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        textSuffix: (
          <TypographyWithI18N
            i18nKey='pastSomeDays'
            options={{ arg1: recentDaysLimit }}
            className='kfic2-metadata'
            color={`${colors.tertiary.darkGray}!important`}
          />
        ),
      }}
      withDivider
    >
      <RecentHiringActivityContentWrapper recentDaysLimit={recentDaysLimit} />
    </Widget>
  );
};

export default RecentHiringActivityWidget;
